import { render, staticRenderFns } from "./Ticketsets.vue?vue&type=template&id=67b4da84&"
import script from "./Ticketsets.vue?vue&type=script&lang=js&"
export * from "./Ticketsets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports